export default "__VITE_ASSET__RIdmFNf7__"